module.exports = __webpack_public_path__ + "img/admin_adv_06.905b4009.png";